import { ICustomizationState } from './types';

export const SLICE_NAMESPACE = 'customization';

export const customizationInitialState: ICustomizationState = {
  banners: [],
  shortcuts: [],
  isLoading: true,
};
